import config from 'services/config'
import { Configuration, FeedbackApi, TotemChatApi } from 'mimir-totem-chat-ts-client'
import store from 'store'
import { camelCase, transform } from 'lodash'
import { responseRoles } from 'services/yggdrasil/chat/chatClient'

const camelize = obj => transform(obj, (acc, value, key, target) => {
    const camelKey = (Array.isArray(target) || (typeof key !== 'string')) ? key : camelCase(key)
    acc[camelKey] = (typeof value === 'object') ? camelize(value) : value
})

const getChatTokenExpirationTime = () => store.getters['ChatBot/getChatTokenExpiration']
const getChatTokenRefreshTime = () => store.getters['ChatBot/getChatTokenRefreshTime']

const getCurrentMemberId = () => store.getters['getUserId']

function getConfiguration () {
    return new Configuration({
        basePath: String(config.mimirUrl.replace(/\/$/, '')),
        baseOptions: {
            withCredentials: true
        }
    })
}

const validateToken = async () => {
    const now = Date.now()
    const timeWindowOffset = 60

    if (
        (now > (getChatTokenExpirationTime() - timeWindowOffset) * 1000) ||
        (now > (config.chatTokenTimeout - timeWindowOffset) * 1000 + getChatTokenRefreshTime())
    ) {
        await store.dispatch('ChatBot/refreshChatToken')
    }
}
const chatApi = new TotemChatApi(getConfiguration())
const feedbackApi = new FeedbackApi(getConfiguration())

export function getClient () {
    return {
        LoadChatSessions: async () => {
            await validateToken()
            return camelize((await chatApi.getAllUsersChats(getCurrentMemberId())).data)
        },
        LoadSingleChatHistory: async (chatId) => {
            await validateToken()
            const response = camelize((await chatApi.getChatById(getCurrentMemberId(), chatId)).data)
            response.messages = response.messages.map(message => {
                if (message.role === responseRoles.ASSISTANT) {
                    message.relatedContent.relatedLearningPaths = message.relatedContent.relatedLearningPath
                }
                return message
            })
            return response
        },
        OpenNewChatSession: async () => {
            await validateToken()
            return camelize((await chatApi.startNewChat(getCurrentMemberId())).data)
        },
        SendMessage: async (message, chatId) => {
            await validateToken()
            const response = camelize((await chatApi.sendMessageToChat(chatId, getCurrentMemberId(), message)).data)
            response.relatedContent.relatedLearningPaths = response.relatedContent.relatedLearningPath
            return response
        },
        SendChatBotFeedBack: async (messageId, chatId, feedbackPayload) => {
            await validateToken()
            return camelize((await feedbackApi.sendFeedbackAboutMessage(getCurrentMemberId(), chatId, messageId, feedbackPayload)).data)
        }
    }
}
